import React, { useContext } from 'react';
import { PersonalizedSectionFetcher, Placeholder } from '@fiverr-private/personalized_content';
import { Container } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { RowSectionComponentProps } from '../../RowSections.types';
import { MetadataContext } from '../../../../context/metadata/metadata.context';
import { UGCContext } from '../../../../context/ugc/ugc.context';
import { useUser } from '../../../../context/user/userProvider';
import { translateAndStoreUgc } from '../../../../shared/utils/machineTranslation/utils';
import { APP_NAME } from '../../../../../../configuration/constants';
import { PersonalizedData } from './PersonalizedRowSection.types';
import { rowSectionConsts } from './constants';

const PersonalizedRowSection = ({ sectionName, setContainerMinHeight }: RowSectionComponentProps) => {
    const { locale } = getContext();
    const { userData } = useUser();
    const { rollouts, currency } = useContext(MetadataContext);
    const { showTranslatedContentRef, ugcMap, addUgcData } = useContext(UGCContext);
    const recommendationsParams = {
        pageName: rowSectionConsts.PERSONALIZED_CONTENT.NAME,
        funnelName: rowSectionConsts.PERSONALIZED_CONTENT.NAME,
    };

    const placeholder = <Placeholder.GigsSectionPlaceholder />;
    const parsedSectionName = sectionName.replace('pcp_', '');

    return (
        <Container data-testid="personalized-row-section" height="100%" width="100%">
            <PersonalizedSectionFetcher
                perseusName={APP_NAME}
                appName={APP_NAME}
                rollouts={rollouts}
                sectionName={parsedSectionName}
                placeholder={placeholder}
                recommendationsParams={recommendationsParams}
                shouldFetchCollections
                extraParams={{
                    currency,
                    displayOptions: {
                        showPrice: true,
                        showContact: true,
                        showSaveExpert: false,
                        showSeeProfile: false,
                        mainCta: 'contact',
                    },
                }}
                showTranslatedUGC={showTranslatedContentRef.current}
                personalizedContent={
                    showTranslatedContentRef.current
                        ? ugcMap.translated.personalizedContent
                        : ugcMap.original.personalizedContent
                }
                onFetchFailed={() => {
                    setContainerMinHeight(0);
                }}
                onFetchSucceeded={async (data?: PersonalizedData) => {
                    translateAndStoreUgc({
                        originalPersonalizedContent: data,
                        targetLocale: locale,
                        userData,
                        addUgcData,
                        grafanaKey: `machine.translate.ugc.personalized_row_section.${locale}`,
                    });
                }}
            />
        </Container>
    );
};

export default PersonalizedRowSection;
